import React, { useState, createContext, useContext } from 'react';
import { LeadModal } from './LeadModal';
interface LeadModalContextType {
  openModal: () => void;
  closeModal: () => void;
}
const LeadModalContext = createContext<LeadModalContextType | undefined>(undefined);
export function LeadModalProvider({
  children
}: {
  children: ReactNode;
}) {
  const [open, setOpen] = useState(false);
  return <LeadModalContext.Provider value={{
    openModal: () => setOpen(true),
    closeModal: () => setOpen(false)
  }} data-id="element-88">
      {children}
      <LeadModal open={open} onClose={() => setOpen(false)} data-id="element-89" />
    </LeadModalContext.Provider>;
}
export function useLeadModal() {
  const ctx = useContext(LeadModalContext);
  if (!ctx) throw new Error('useLeadModal must be used inside LeadModalProvider');
  return ctx;
}